"use client"
import { toast } from "sonner"
import { Result } from "@praha/byethrow"
import { useAsync, useServerState } from "@mylaunch/components/hooks"
import { ImSpinner2 } from "react-icons/im"
import { Drawer, DrawerContent, DrawerTitle } from "@mylaunch/components/ui"
import { Button } from "~/components/ui/button"
import { DrawerCover } from "~/components/ui/drawer-cover"
import type { Group } from "@apps/gwservice/types"
import { cancelAccessRequest, requestAccess } from "../server/catalog.functions"

function Body({ group, access, loading, onToggle }: { group: Group; access: Group["access"]; loading: boolean; onToggle: () => void }) {
  return (
    <>
      {group.avatar && <DrawerCover imageUrl={group.avatar.url} mimeType={group.avatar.mimeType} />}
      <div className="flex flex-col gap-s p-m mb-m">
        <div lang="ru" className="font-bold text-xl hyphens-auto">{group.name}</div>
      </div>
      <Button size="lg" className="sticky bottom-m mx-m !w-auto" disabled={loading} onClick={onToggle}>
        {loading ? <ImSpinner2 className="animate-spin" /> : access === "pending" ? "Отменить заявку" : "Вступить"}
      </Button>
    </>
  )
}

const toggleAccess = (id: number, access: Group["access"]) => {
  if (access === "pending") {
    return cancelAccessRequest({
      data: {
        kind: "group",
        targetId: id,
      },
    })
  }

  return requestAccess({
    data: {
      kind: "group",
      targetId: id,
    },
  })
}

export function GroupAccessSheet({ group, open, onClose }: { group: Group; open: boolean; onClose: () => void }) {
  const [access, setAccess] = useServerState(group.access)
  const { loading, run } = useAsync(toggleAccess)
  const handle = async () => {
    const result = await run(group.id, access)
    if (Result.isFailure(result)) {
      toast.error(access === "pending" ? "Не удалось отменить заявку" : "Не удалось отправить заявку")
      return
    }
    setAccess(result.value)
  }
  return (
    <Drawer open={open} onOpenChange={(open) => !open && onClose()}>
      <DrawerContent handle={false} showCloseButton={!group.avatar} className="rounded-t-xl p-0 gap-0 border-0 outline-none max-h-[80vh] overflow-y-auto">
        <DrawerTitle className="sr-only">{group.name}</DrawerTitle>
        <Body group={group} access={access} loading={loading} onToggle={handle} />
      </DrawerContent>
    </Drawer>
  )
}
